import { render, staticRenderFns } from "./ReleaseNotesModalList.vue?vue&type=template&id=d22ca87c&scoped=true"
import script from "./ReleaseNotesModalList.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesModalList.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesModalList.vue?vue&type=style&index=0&id=d22ca87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22ca87c",
  null
  
)

export default component.exports